import { Link } from "react-router-dom";
import React from "react";
import { LuTickets } from "react-icons/lu";
import { CiLogout, CiLogin, CiUser } from "react-icons/ci";
import { PiCardsBold } from "react-icons/pi";
import { IoMdClose } from "react-icons/io";
import { MdWorkOutline } from "react-icons/md";

/* eslint-disable react/prop-types */
const MobileMenu = React.forwardRef(({ setIsOpen, isAuthenticated, logout }, ref) => {
    const authenticatedLinks = (
        <>
            <Link
                to="/tickets"
                className="block p-4 py-6 hover:bg-zinc-900  bg-opacity-30 border-b border-zinc-100 text-lg  transition"
                onClick={() => setIsOpen(false)}
            >
                <div className="flex gap-2 items-center">
                    <LuTickets />
                    Mis Tickets
                </div>
            </Link>
            <button
                className="w-full text-left p-4 py-6 hover:bg-zinc-900  bg-opacity-30 border-b border-zinc-100 text-lg  transition"
                onClick={() => {
                    logout();
                    setIsOpen(false);
                }}
            >
                <div className="flex gap-2 items-center">
                    <CiLogout className="text-lg" />
                    Cerrar Sesión
                </div>
            </button>
        </>
    );

    const guestLinks = (
        <>
            <Link
                to="/login"
                className="block p-4 py-6 hover:bg-zinc-900  bg-opacity-30 border-b border-zinc-100 text-lg  transition"
                onClick={() => setIsOpen(false)}
            >
                <div className="flex gap-2 items-center">
                    <CiLogin className="text-lg" />
                    Iniciar Sesión
                </div>
            </Link>
            <Link
                to="/register"
                className="block p-4 py-6 hover:bg-zinc-900  bg-opacity-30 border-b border-zinc-100 text-lg  transition"
                onClick={() => setIsOpen(false)}
            >
                <div className="flex gap-2 items-center">
                    <CiUser className="text-lg" />
                    Registrarse
                </div>
            </Link>
        </>
    );

    return (
        <div ref={ref} className="fixed inset-0 flex justify-end z-50 backdrop-blur-sm">
            <div className="bg-zinc-950 bg-opacity-100 w-64 h-full shadow-xl p-4 overflow-y-auto">
                {/* Botón de cerrar */}
                <div className="flex justify-end mb-8">
                    <button
                        onClick={() => setIsOpen(false)}
                        className=" mr-2"
                        aria-label="Cerrar Menu"
                    >
                        <IoMdClose className="text-3xl" />
                    </button>
                </div>

                {/* Enlaces */}
                <Link
                    to="/eventos"
                    className="block p-4 py-6 hover:bg-zinc-900  bg-opacity-30 border-b border-zinc-100 text-lg"
                    onClick={() => setIsOpen(false)}
                >
                    <div className="flex gap-2 items-center">
                        <PiCardsBold />
                        Eventos
                    </div>
                </Link>
                <Link
                    to="/producers"
                    className="block p-4 py-6 hover:bg-zinc-900  bg-opacity-30 border-b border-zinc-100 text-lg"
                    onClick={() => setIsOpen(false)}
                >
                    <div className="flex gap-2 items-center">
                        <MdWorkOutline />
                        Productoras
                    </div>
                </Link>

                {isAuthenticated ? authenticatedLinks : guestLinks}
            </div>
        </div>
    );
});

MobileMenu.displayName = "MobileMenu";

export default MobileMenu;
